import React, { useEffect, useState } from 'react';
import { Table } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { ActiveUserMetricColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/ActiveUsersCloums';
import { DateColumns } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/DateCloums';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { useIntl } from 'umi';
import { getCompanyRevenueDownloadValueOfCvm } from '../_utils';

const { pageable, scrollable } = Table.addons;

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    pageId,
    dateType,
    dataSource = 'appannie',
    columnsList,
    entityType = '',
  } = props;
  const { formatMessage } = useIntl();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState({
    currentSortValue: 'desc',
    currentSortMetric: 'date',
    currentRatioType: 0,
  });
  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    // currentOrderSource,
  } = pageSortAttr || {};

  useEffect(() => {
    onSortChage({
      sortMetric: pageSortAttr.currentSortMetric,
      sortVal: 'desc',
      ratioType: 0,
    });
  }, [JSON.stringify(tableData)]);

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData,
      sortParams: e,
      timeProperty: 'date',
      metricProperty: 'metric',
      growthProperty: 'dod',
    });
    setSortTableData(sortTable.slice(0));
  };

  const getMetricCloums = (dataSource: string) => {
    const metricCloums: any[] = [];
    columnsList?.forEach((t: any) => {
      metricCloums.push(
        ActiveUserMetricColumn({
          dataSource: dataSource === 'ogdb' ? 'databarin' : dataSource,
          title: t.title,
          textContent: t.textContent,
          key: `${t.value}_${dataSource}`,
          sortMetric: t.value,
          currentSortValue,
          currentSortKey: `${currentSortMetric}_${dataSource}_${currentRatioType}`,
          onSortChage,
          width: columnsList?.length === 1 ? 'auto' : t?.width,
          width_cn: columnsList?.length === 1 ? 'auto' : t?.width_cn,
          getMetricValueOfCvm: (cvm: any, sortMetric: string) => {
            const metrics = cvm?.metrics || [];
            const metric = metrics.find((item: any) => {
              return item?.metric === sortMetric;
            });
            return getCompanyRevenueDownloadValueOfCvm(metric);
          },
          entityType,
        }),
      );
    });
    return metricCloums;
  };

  return (
    <>
      <Table
        bordered="all"
        records={sortTableData}
        className="dbi-mobileGames-details-table"
        columns={[
          DateColumns({
            key: 'date',
            sortMetric: 'date',
            title: formatMessage({ id: `dbi_date` }),
            currentSortMetric,
            currentSortValue,
            dateType,
            onSortChage,
            width: 180,
          }),
          ...getMetricCloums(dataSource),
        ]}
        addons={[
          pageable({
            stateTextVisible: true,
            pageSizeVisible: sortTableData?.length > 5,
            pageIndexVisible: sortTableData?.length > 5,
            jumpVisible: sortTableData?.length > 5,
            endJumpVisible: sortTableData?.length > 5,
            pageSizeOptions: [5, 10, 15],
            stateText: formatMessage(
              { id: 'dbi_pagination_total' },
              { total: sortTableData?.length ?? 0 },
            ),
          }),
        ]}
      />
    </>
  );
};

export default TrendsCard;
